export const routes = {
  ADD_PROJECT: '/add',
  ADMIN: '/admin',
  FOLIO: '/folio',
  ABOUT: '/about',
  PROCESS: '/process',
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  CONTACT: '/contact'
};

export const colors = {
  primary: '#f9e7cc',
  dark: '#333333',
  link: '#ab3029'
};



// WEBPACK FOOTER //
// ./src/constants/index.js